<template>
    <section class="faq-section" id="faq">
        <div class="question-shevrone">
            <img src="../assets/icons/question-shevrone.svg" alt="">
        </div>
        <div class="container">
            <div class="row center-lg align-left">
                <div class="col-xs-12 col-gi-10">
                    <h3 class="section-title faq-title margin-bottom bordered-heading headline_h2">FAQ – <br>Häufig gestellte Fragen</h3>
                    <div class="faq-container">
                        <div class="faq-card" v-for="(faq, index) in faqList" :key="index">
                            <div class="faq-title text" :class="{active: selectedIndex === index}" @click="toggle(index)">{{ faq.title }}</div>
                            <CollapseTransition dimension="height">
                                <div class="faq-content text" v-show="selectedIndex === index" v-html="faq.description"></div>
                            </CollapseTransition>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import { CollapseTransition } from "@ivanv/vue-collapse-transition"
export default {
    name: "FAQ",
    components: {
        CollapseTransition
    },
    data: () => ({
        selectedIndex: null,
        faqList: [
            {
                title: 'Was ist mein Auto wert?',
                description: 'Dein Autowert ist abhängig vom Alter, Laufleistung, Zustand und der verbauten Sonderausstattung. Bei der Autobewertung unterscheiden wir zwischen werterhöhenden Faktoren, wie Sonderausstattung, gutem Pflegezustand, oder nachträglich verbautem Zubehör und wertmindernden Faktoren, wie Mängel an der Karosserie, Technik oder  Unfallschäden.'
            },
            {
                title: 'Wie funktioniert die Autobewertung?',
                description: 'Der Preis wird transparent, fair und marktaktuell durch unsere TÜV-Rheinland-zertifizierte Marktwertanalyse ermittelt. Dabei werden alle wertbeeinflussenden Faktoren, wie Ausstattung, Alter, Laufleistung etc., berücksichtigt. Je mehr Informationen eingegeben werden, desto besser können wir den Autowert ermitteln.'
            },
            {
                title: 'Wie lange dauert eine Fahrzeugbewertung?',
                description: 'Unsere Fahrzeugbewertung ist blitzschnell - es dauert knapp 1 Minute vom ersten Klick bis du den TÜV-Rheinland-zertifizierten Marktwert deines Autos bequem per E-Mail zugeschickt bekommst.',
            },
            {
                title: 'Wie genau ist die Autobewertung die ich per E-Mail erhalte?',
                description: 'Der Autowert wird anhand von Millionen Marktdaten tagesaktuell berechnet. Die Ermittlung des Autowertes erfolgt zustandsneutral. Das bedeutet, technischer und optischer Zustand können dabei nicht berücksichtigt werden, der Wert könnte nach der Prüfung durch einen Gutachter noch einmal angepasst werden. Die Genauigkeit unseres Algorithmus hat der TÜV Rheinland geprüft und bestätigt.',
            },
            {
                title: 'Was kostet die Fahrzeugbewertung?',
                description: 'Für dich entstehen keine Kosten, du bekommst deine Fahrzeugbewertung bequem per E-Mail. Auch falls du später dein <a href="https://www.pkw.de/auto-verkaufen/">Auto verkaufen</a> möchtest, fallen für dich keine Kosten an, denn auch Abholung und Abmeldung sind für dich kostenlos.',
            },
            {
                title: 'Kann ich mein Auto jetzt bewerten lassen und später verkaufen?',
                description: 'Natürlich! Du kannst deine Autobewertung in deinem PKW.de Kundenkonto speichern und erst bei Bedarf ein Höchstgebot erhalten. Die Abholung und Abmeldung deines Autos sind für dich kostenlos. <br/><br/> Mehr Informationen erhältst du auf: <a href="https://www.pkw.de/auto-verkaufen/">https://www.pkw.de/auto-verkaufen/</a>'
            },
            {
                title: 'Muss ich mich registrieren, um meinen Autowert berechnen zu lassen?',
                description: 'Nein. Nachdem du deine Fahrzeugdaten eingegeben hast, erhältst du deine TÜV-Rheinland-zertifizierte Autobewertung direkt per E-Mail.',
            },
            {
                title: 'Sollte ich ein geerbtes Auto bewerten lassen?',
                description: 'Gerade im Erbfall ist es wichtig, schnell und unbürokratisch einen Eindruck vom Restwert eines Autos zu erhalten. Denn so kann sich ein Erbe oder eine Erbengemeinschaft schnell einen Überblick verschaffen und das weitere Vorgehen bei einem Erbfall besprechen: Verkaufen oder Behalten? Wichtig: Ist das Fahrzeug mehr als 12.000 Euro wert, muss die Differenz versteuert werden. Mit der schnellen Fahrzeugbewertung bei PKW.de hast du in einer Minute die Antwort, ob das bei deinem Fahrzeug der Fall ist.'
            },
            {
                title: 'Kann ich für mein Auto auch einen höheren Preis erzielen?',
                description: 'Ja, denn die Nachfrage nach Gebrauchtwagen ist zurzeit hoch. Durch ein Auktionsverfahren, bei dem tausend zertifizierte Händler teilnehmen, können wir ein Höchstgebot für dein Auto erzielen. Du entscheidest erst danach, ob du zum Höchstgebot verkaufen möchtest und  vermeidest lästiges Nachverhandeln. Abholung und Abmeldung deines Autos sind für dich kostenlos. <br/><br/> Mehr Informationen: <a href="https://www.pkw.de/auto-verkaufen/">https://www.pkw.de/auto-verkaufen/</a>'
            }
        ]
    }),
    methods: {
        toggle(index) {
            if(this.selectedIndex === index) {
                this.selectedIndex = null;
            } else {
                this.selectedIndex = index;
            }
        }
    },
}
</script>

<style lang="scss" scoped>
    @import "~@/assets/vars";

    .faq-section {
        position: relative;
        border-top: 3px solid #C0141B;
        padding:40px 0 20px;

        @include breakpoint(frommediumlarge) {
            padding:50px 0;
        }

        @include breakpoint(fromgiant) {
            padding:100px 0;
        }

        .question-shevrone {
            position: absolute;
            top: 0;
            left: 18px;

            @include breakpoint(fromgiant) {
                left: 10vw;
            }
            @media (min-width: 2150) {
                left: calc(50vw - (1300px / 2));
            }
        }

        h3.faq-title {
            br {
                @include breakpoint(frommediumlarge) {
                    display:none;
                }
            }
        }
    }
    .faq-container {
        padding-top:17px;

        @include breakpoint(frommediumlarge) {
            padding-top:0;
        }

        @include breakpoint(fromgiant) {
            padding-top:17px;
        }
        &.responsive {
            @media screen and (min-width:650px) {
                display: grid;
                gap: 0 18px;
                grid-template-columns: 1fr 1fr;
            }
        }
    }

    .section-title {
        margin-top: 40px;

        @include breakpoint(fromgiant) {
            margin-top: initial;
        }
    }
    .faq-card {
        margin-bottom: 25px;
        display:block;

        .question {
            display:flex;
            align-items: center;
            justify-content: flex-start;

            .prefix-icon {
                margin-right:13px;
                padding-top:4px;
                .icon {
                    font-size:32px;
                }

                &.small-icon {
                    .icon {
                        font-family: 'Glyphter', sans-serif;
                        color:rgba(#444,.5);
                        font-size:20px;
                    }
                }
            }
        }
        .faq-title {
            background-color: $white;
            border:1px solid $border-color;
            border-radius: 4px;
            cursor: pointer;
            padding: 20px;
            padding-right: 44px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            color:$black-variant;
            position:relative;
            transition:300ms background-color ease-in-out, 300ms color ease-in-out, 300ms border ease-in-out;


            &:after {
                font-family: "Material Icons";
                content: "\e145";
                position:absolute;
                display:block;
                top:18px;
                right:19px;
                color:#DADADA;
                font-size:24px;
                transition:300ms color ease-in-out;
            }

            .question {
                width:calc(100% - 30px)
            }

            &:hover,
            &:focus,
            &:active,
            &.active {
                background-color: $red;
                border:1px solid $red;
                color: #fff;

                &:before {
                    color:$white;
                }
            }
        }
        .faq-content {
            display:block;
            padding: 24px 0 4px;
            padding-left:0 !important;
            padding-right: 0 !important;
        }
    }
</style>



// WEBPACK FOOTER //
// src/landing-components/FAQ.vue